import { render, staticRenderFns } from "./Statistics_DirectBookings.vue?vue&type=template&id=32e17521&scoped=true&"
import script from "./Statistics_DirectBookings.vue?vue&type=script&lang=js&"
export * from "./Statistics_DirectBookings.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_DirectBookings.vue?vue&type=style&index=0&id=32e17521&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e17521",
  null
  
)

export default component.exports